<template>
  <v-container
    grid-list-md
  >
    <RoleListCondition
      :cond="cond"
    />
    <v-layout row>
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-data-table
            :headers="headers"
            :items="roles"
            :disable-initial-sort="true"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td @click="onRoleSelected(item)">
                {{ item.name }}
              </td>
              <td @click="onRoleSelected(item)">
                {{ item.users.length }}
              </td>
              <td
                @click="onRoleSelected(item)"
              >
                <v-icon
                  v-if="!item.editable"
                >
                  mdi-lock
                </v-icon>
              </td>
            </template>
          </v-data-table>
        </MaterialCard>
      </v-flex>
      <v-flex
        md4
      >
        <RoleDetail
          v-if="selected != null"
          :role="selected"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { RoleDetail, RoleListCondition } from './components'

export default {
  components: {
    RoleDetail,
    RoleListCondition
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await search(to.query)
      next(vm => {
        vm.init(response)
      })
    } catch (e) {
      next(e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      const response = await search(to.query)
      this.init(response)
      next()
    } catch (e) {
      next(e)
    }
  },
  data: () => ({
    cond: {
      name: ''
    },
    headers: [
      { sortable: false, text: 'グループ名', value: 'name' },
      { sortable: false, text: '人数' },
      { sortable: false, text: '' }
    ],
    allRoles: [],
    selected: null
  }),
  computed: {
    roles () {
      if (this.cond.name === '') {
        return this.allRoles
      } else {
        const name = this.cond.name.toLowerCase()
        return this.allRoles.filter(g => g.name.toLowerCase().indexOf(name) !== -1)
      }
    }
  },
  methods: {
    init (value) {
      const { roles } = value
      this.allRoles = roles
    },
    onRoleSelected (item) {
      this.selected = item
    }
  }
}

export const search = async (query) => {
  const response = {
    roles: [
      {
        id: 1,
        name: '管理者',
        description: 'GoNOW標準の管理者権限です。',
        editable: false,
        users: [
          { id: 1, name: 'ユーザー1' },
          { id: 2, name: 'ユーザー2' }
        ]
      },
      {
        id: 2,
        name: '配送員',
        description: 'GoNOW標準の配送員です。',
        editable: false,
        users: [
          { id: 2, name: 'ユーザー2' },
          { id: 3, name: 'ユーザー3' },
          { id: 4, name: 'ユーザー4' },
          { id: 5, name: 'ユーザー5' }
        ]
      },
      {
        id: 3,
        name: 'アルバイト',
        description: 'アルバイト',
        editable: true,
        users: [
          { id: 1, name: 'ユーザー1' },
          { id: 2, name: 'ユーザー2' }
        ]
      }
    ]
  }

  return response
}
</script>
